var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('rect',{attrs:{"width":"15","height":"15","x":".5","y":".5","stroke":"currentColor","stroke-width":"2","rx":"3.5"}}),_c('path',{attrs:{"fill":"currentColor","d":"M12.416 8.65H9.177v2.906H7.683V8.649H4.444V7.367h3.239V4.444h1.494v2.923h3.239z"}})])
}
var staticRenderFns = []

export default { render: render }